function ArrowDown({
  height,
  width,
  color = "FFF",
}: {
  height: string;
  width: string;
  color?: string;
}): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 7"
    >
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 1l5 5 5-5"
      ></path>
    </svg>
  );
}

export { ArrowDown };
